import { formatting } from "@/lib/formatting";

import { TrophyAwardType, TrophyValueUnit } from "@/types";

export const trophies = {
  value: (
    type: TrophyAwardType,
    value: number,
    unit: TrophyValueUnit | null,
  ): string => {
    if (type === TrophyAwardType.REVENUE) return formatting.currency(value);
    if (type === TrophyAwardType.FASTEST_PLACEMENT) {
      const label = unit === TrophyValueUnit.HOURS ? "hour" : "day";
      return `${value.toLocaleString("en-US")} ${value === 1 ? label : `${label}s`}`;
    }
    if (type === TrophyAwardType.MOST_VERSATILE) {
      return `${value.toLocaleString("en-US")} companies`;
    }
    if (type === TrophyAwardType.SCREENS) {
      return `${value.toLocaleString("en-US")} screens`;
    }
    if (type === TrophyAwardType.SUBMITTALS) {
      return `${value.toLocaleString("en-US")} submissions`;
    }
    if (type === TrophyAwardType.INTERVIEWS) {
      return `${value.toLocaleString("en-US")} interviews`;
    }
    return `${value.toLocaleString("en-US")} placements`;
  },
};
